import _extends from "@babel/runtime/helpers/extends";
import { useCallback, Fragment } from "react";
import { useBannerOrBlocker } from "..";
import { FooterLink, FooterPoweredByLink } from "../../components";
import { jsxJoin } from "@devowl-wp/react-utils";
function useCommonFooterLinks() {
  let {
    onClose,
    putPoweredByLinkInRow,
    row1,
    row1End
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    i18n: {
      close
    },
    footerDesign: {
      poweredByLink
    },
    poweredLink,
    links = [],
    affiliate
  } = useBannerOrBlocker();
  const targetBlankAttributes = {
    target: "_blank",
    rel: "noopener"
  };
  const rows = [
  // Row 1
  [onClose && h(FooterLink, {
    href: "#",
    onClick: onClose,
    key: "close",
    "interaction-player-skip": "1"
  }, h("strong", null, close)), ...(row1 || []), ...links.map((_ref, i) => {
    let {
      label,
      url,
      isTargetBlank
    } = _ref;
    return !!label && !!url && h(FooterLink, _extends({
      key: `${i.toString()}-links`,
      href: url
    }, isTargetBlank === undefined || isTargetBlank ? targetBlankAttributes : {}), label);
  }), ...(row1End || [])].filter(Boolean),
  // Row 2
  [] // Nothing yet
  ];

  if (!!poweredLink && poweredByLink) {
    rows[putPoweredByLinkInRow || 0].push(h(FooterPoweredByLink, {
      key: "poweredBy",
      poweredLink: poweredLink,
      affiliate: affiliate
    }));
  }
  const render = useCallback(rows => jsxJoin(rows.map(row => row.length ? h(Fragment, {
    key: row[0].key
  }, jsxJoin(row, h(Fragment, null, " \u2022 "))) : null), h("br", {
    "aria-hidden": true
  })), []);
  return {
    rows,
    render
  };
}
export { useCommonFooterLinks };